import { render } from "./ListProperties.vue?vue&type=template&id=5d1062da"
import script from "./ListProperties.vue?vue&type=script&lang=js"
export * from "./ListProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__